<template>
    <v-sheet style="height:100%" v-if="is_loggedin">
        
        <TopToolbar @open_wizard="open_wizard" />

        <v-container full-width style="height:100%">      
                 
            <v-alert v-if="show_alert" prominent type="error">
                <v-row align="center">
                    <v-col class="grow">
                        {{message_validation}}
                    </v-col>
                    <v-col class="shrink">
                      
                        <v-btn 
                        text
                        v-show="!($route.path.indexOf('settings')>=0)"
                        :to="{name:'settings'}">FAZER AGORA</v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <router-view></router-view>
        </v-container>

        <wizard ref="wizard" />

        <BottomToolbar />
    </v-sheet>
</template>

<script>
import TopToolbar from "../../components/shared/topbar.vue";
import BottomToolbar from "../../components/shared/bottombar.vue";
import wizard from "../../components/wizard/inicial";

export default {
    components: {
        TopToolbar,
        BottomToolbar,
        wizard,
    },
    data: () => ({
        activeBtn: 1,
        message_validation:null
    }),
    computed:{
        show_alert(){
            var zipcode = this.$store.getters.user.myself.address_zipcode;            
            var show_zip = (zipcode == null || zipcode == undefined || zipcode == "" ? true : false);            
            if(!show_zip){
                var baccount = this.$store.getters.user.artists[0].bank_account;
                var show_baccount = (baccount == null || baccount == undefined || baccount == "" ? true : false)
                var typeSolo =  this.$store.getters.user.artists[0].type == "solo"
                var company = this.$store.getters.user.artists[0].is_company
                var show_baccountCompanySolo = (typeSolo || company)
                if(show_baccount && show_baccountCompanySolo){
                    this.message_validation = "Por favor atualize seus dados bancários.";
                    this.$store.dispatch("global_alert_showing_update", {msg:"Você precisa cadastrar uma conta bancária para receber o pagamento dos seus direitos.", tab:3});
                    return true;
                }else{
                     this.$store.dispatch("global_alert_showing_update",null)
                    return false;
                }
            }
            this.message_validation = "Por favor atualize o seu endereço.";
             this.$store.dispatch("global_alert_showing_update",{msg:"Precisamos que você cadastre o seu endereço antes de continuar.", tab:0});
            return true;            
        }
    },

    beforeCreate() {
        //enviar para o login caso esteja deslogado
        if (!this.$store.getters.is_loggedin) {
            this.$router.push({ name: "login" });
        }

     
    },
    beforeMount(){
           //verificar se o usuário tem endereço
        /*var user = this.$store.getters.user;
        var zipcode = user.myself.address_zipcode;
        if(!zipcode || zipcode=="" ){
            this.message_validation = "Por favor atualize o seu endereço.";
        }else{
            if(!user.artists[0].bank_account){
                this.message_validation = "Por favor atualize suas informações de pagamento.";
            }
        }*/
    },
    methods: {
        is_loggedin() {
            return this.$store.getters.is_loggedin;
        },
        open_wizard() {
            this.$refs.wizard.start("inicial");
        }
    }
};
</script>
